
<div class="landingcls">
    <div class="landingCards">
        <div class="col-lg-12 mx-auto mousePointer">
            <div class="row landingCardstop">
                <div class="{{isBFMInternal?'col landing_cardDivDisabled':'col'}}">
                    <a name="landing_policyquote" title="View all Policies and Quotes" id="landing_policyquoteID"
                        href="/xps/search" class="{{isBFMInternal?'landing_card text-center landing_cardDisabled':'landing_card text-center'}}">
                        <img name="landing_policyquoteImg" id="landing_policyquoteImgID"
                            src="xps/assets/img/viewpolicy_1.png">
                        <h5>View all Policies and Quotes</h5>
                    </a>
                </div>
                <div class="col">
                    <a name="landing_managepolicy" title="Manage a Policy" id="landing_managepolicyID"
                        class="landing_card text-center" (click)="policy('Manage a Policy')" href="/xps/policyQuotes">
                        <img name="landing_managepolicyImg" id="landing_managepolicyImgID"
                            src="xps/assets/img/managingpolicy_1.png">
                        <h5>Manage a Policy</h5>
                    </a>
                </div>
                <div class="col">
                    <a name="landing_reportClaim" title="Report a Claim" href="/xps/reportclaim" id="landing_reportClaimID"
                        class="landing_card text-center">
                        <img name="landing_reportClaimImg" id="landing_reportClaimImgID"
                            src="xps/assets/img/reportpolicy_1.png">
                        <h5>Report a Claim</h5>
                    </a>
                </div>
                <div class="col">
                    <a name="landing_evidenceInsurance" title="Request Evidence of Insurance"
                        id="landing_evidenceInsuranceID" class="landing_card text-center" href="/xps/evidenceofinsurance">
                        <img name="landing_evidenceInsuranceImg" id="landing_evidenceInsuranceImgID"
                            src="xps/assets/img/evidence_2.png">
                        <h5>Request Evidence of Insurance</h5>
                    </a>
                </div>
                <div class="col">
                    <a name="landing_cancelPolicy" title="Cancel a Policy" id="landing_cancelPolicyID"
                        href="/xps/policyQuotes" (click)="policy('Cancel My Policy')" class="landing_card text-center">
                        <img name="landing_cancelPolicyImg" id="landing_cancelPolicyImg"
                            src="xps/assets/img/cancelpolicy.png">
                        <h5>Cancel a Policy</h5>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-1  landingInfo">
        <div class="col-lg-1 col-md-1 col-sm-1 col-4">
            <i class="fa fa-info-circle infoicon landingInfo_Icon"
            aria-hidden="true"></i>
        </div>
        <div class="col-lg-11 col-md-11 col-sm-11 col-8">
            <p class="landingInfo_Content">
                If you need help with Policy Changes, Claims, Coverage or Billing Questions, contact Berkley Fire &
                Marine Support
            </p>
        </div>
    </div>
</div>